(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('ScriptsTypes', ScriptsTypes);

    ScriptsTypes.$inject = ['$resource'];

    function ScriptsTypes ($resource) {
        var resourceUrl =  'api/scripts-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
